<template>
  <!-- eslint-disable-next-line max-len -->
  <div
    class="flex flex-row items-center justify-between w-full h-20 my-16 md:justify-center w-96 md:mx-0 bg-nuts-amber-400 rounded-xl"
  >
    <img class="md:pl-8" src="@/assets/auto-delivery/nuts-poping.svg" alt="Nuts poping icon" />
    <p class="m-0 text-base font-bold font-sofia-pro escape-legacy">
      View Products Eligible <br />
      For Auto-Delivery
      <RouterLink to="/autodelivery-bestsellers/" class="text-black no-underline hover:underline"
        >Here</RouterLink
      >
    </p>
    <img
      class="md:pr-8"
      src="@/assets/auto-delivery/pop-corn-poping.svg"
      alt="Pop Corn poping icon"
    />
  </div>
</template>
